import { FC, JSX, useMemo } from "react";
import { EllipsisTooltip } from "@app/shared/EllipsisTooltip";
import { MarketplacePayerPlanCount } from "@app/overviews/market-expansion-dashboard/shared/MarketplaceCountyPlanCounts";

const TOP_PAYERS_LIMIT = 5;

interface MarketplaceTopPayersTableProps {
  payers: MarketplacePayerPlanCount[];
}

const MarketplaceTopPayersTable: FC<MarketplaceTopPayersTableProps> = ({ payers }): JSX.Element => {
  const sortedPayers = useMemo(
    () => payers.slice().sort((a, b) => b.planCount - a.planCount).slice(0, TOP_PAYERS_LIMIT),
    [payers]
  );

  if (!sortedPayers.length) {
    return <></>;
  }

  return (
    <table className="county-summary-popup__table marketplace-payers-table" data-testid="marketplace-top-payers-table">
      <thead className="visually-hidden">
        <tr>
          <th scope="col">Payer</th>
          <th scope="col">Plan Count</th>
        </tr>
      </thead>
      <tbody>
        {sortedPayers.map((payer: MarketplacePayerPlanCount, index: number) => (
          <tr key={payer.payerName} data-testid={`marketplace-top-payers-table__row-${index + 1}`}>
            <td className="payer-data" data-testid={`marketplace-top-payers-table__payer-name-${payer.payerName}`}>
              <EllipsisTooltip text={payer.payerName} width="100%" position="top" />
            </td>
            <td className="plan-count-data" data-testid={`marketplace-top-payers-table__plan-count-${payer.payerName}`}>
              {payer.planCount.toLocaleString()}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MarketplaceTopPayersTable;
